<template lang="pug">
  include ../tool/CommonList.pug


</template>


<script>
  import {Model, EditDialog} from "./imports.js"
  import CommonList from "../tool/CommonList.js"

  export default {
    extends: CommonList,
    components: {
      EditDialog
    },
    data: () => ({
    }),
    computed: {
    },
    watch: {
    }, 
    methods: {
      loadModel: function() {
        this.model = new Model()
      },

      isViewAllowed: function() {
        return true
      },
      isDeleteAllowed: function() {
        return false
      },
      setup () {
        this.headers = [
          {align: "start", width: "10", text: this.model.content + "." + 'pos', value: 'pos', sortable: false},
          //{align: "start", width: "30", text: this.model.content + "." + 'type', value: 'type', sortable: false},
          {align: "start", width: "100", text: this.model.content + "." + 'reference', value: 'reference', sortable: false},
          {align: "start", width: "100", text: this.model.content + "." + 'label', value: 'label', sortable: false},
          //{align: "center", width: "60", text: this.model.content + "." + 'unit', value: 'unit', sortable: false},
          {align: "center", width: "60", text: this.model.content + "." + 'price_ht', value: 'price_ht', sortable: false},
          // {align: "center", width: "60", text: this.model.content + "." + 'is_subscribtion', value: 'is_subscribtion', sortable: false},
          // {align: "center", width: "60", text: this.model.content + "." + 'is_card', value: 'is_card', sortable: false},
  
          {align: "center", width: "60", text: 'common.created_date', value: 'created_date', sortable: false},
          {align: "center", width: "30", text: 'common.actions', value: 'name', sortable: false }
        ]


       this.columns = [
          {class: "handle", text: '::'},
          //{class: "text-left", value: 'type', format: this.translateType},
          {class: "text-left", value: 'reference'},
          {class: "text-left", value: 'label'},
          //{class: "text-right", value: 'unit'},
          {class: "text-right", value: 'price_ht', format: this.formatCurrency},
          // {class: "text-center", value: 'is_subscribtion', format: this.formatBoolean},
          // {class: "text-center", value: 'is_card', format: this.formatBoolean},
          
          {class: "text-center", value: 'created_date', format: this.formatDatetime},
        ]
      
      },
      translateType: function (value) {
        return this.$t(this.model.content + "." + "type_" + value)
      },
      
    },

  }

</script>
